<template>
    <div class="setting-advanced-robot">
        <div class="setting-advanced-robot-num-tips" v-if="showMsgTips">
            <p>自动消息剩余数量<span class="msg-leave-num">{{messageCount}}</span><span v-if="+messageCount">条</span></p>
            <svg-icon icon-class="close" class="robot-num-close-btn" @click.native="closeTips"></svg-icon>
        </div>
        <div class="module-item-style">
            <div class="module-item-title robot-title-with-switch">
                <div>
                    机器人开关
                </div>
                <div class="advanced-robot-switch-btn">
                    <el-switch
                            v-model="robotSwitch"
                            @click.native="saveChange('is_open_robot',robotSwitch)"
                            active-color="#68B974">
                    </el-switch>
                </div>
            </div>
            <div class="advanced-robot-tips">1、默认关闭，开启后机器人自动匹配知识库问题与访客进行聊天对话；</div>
            <div class="advanced-robot-tips" style="margin-top: -20px">2、机器人依赖知识库中的内容为顾客提供服务，请提前设置
                <router-link class="link-to-knowledge" to="/setting-advanced-knowledge" tag="span">前往设置</router-link>
            </div>
            <div class="advanced-content-container" v-if="showRobotConfig">
                <div class="can-edit-div-box" v-if="false">
                    <div contenteditable="true" class="can-edit-div" data-placeholder="您好，当前有专业客服人员在线，随时与我们联系。"></div>
                </div>
                <div>
                    <div class="small-title">机器人客服</div>
                    <div class="robot-info-container">
                        <div class="robot-avatar">
                            <img :src="robotHeadImg" alt="头像">
                        </div>
                        <div class="wl-btn" @click="changeRobotAvatar">
                            修改头像
                        </div>
                        <input type="file" @change="inputChange" ref="robotAvatar" style="display: none;">
                    </div>
                    <div class="robot-name">
                        <span class="robot-name-label">机器人名字</span>
                        <el-input class="robot-name-input" maxlength="32" @change="editRobotInfo" v-model="robotName"
                                  placeholder="请输入内容"></el-input>
                    </div>
                </div>
            </div>
        </div>

        <!-- AI 智能客服开关 -->
        <div class="module-item-style" v-if="showRobotConfig">
            <div class="module-item-title robot-title-with-switch">
                <div>AI 智能客服</div>
                <div class="advanced-robot-switch-btn">
                    <el-switch v-model="aiRobotSwitch"
                            @click.native="saveChange('is_open_ai_robot', aiRobotSwitch)"
                            active-color="#68B974">
                    </el-switch>
                </div>
            </div>
            <div class="advanced-robot-tips">开启后，机器人将使用 AI 智能回复，提供更自然的对话体验</div>
        </div>

        <div class="module-item-style" v-if="showRobotConfig">
            <div class="module-item-title">机器人模式选择</div>
            <div class="advanced-robot-tips">选择机器人的工作条件和优先级</div>
            <div class="advanced-content-container">
                <el-radio-group v-model="robotRule" class="robot-model-container"
                                @change="saveChange('robot_rule',robotRule)">
                    <el-radio class="model-item" label="agent_first">仅在客服离线或客服接待达到上限<span class="model-item-desc">(当人工客服在线，并且接待上限没有占满时，就会优先分配给人工客服)</span>
                    </el-radio>
                    <el-radio class="model-item" label="robot_first">所有顾客优先由机器人接待<span class="model-item-desc">(所有对话都将由机器人优先接待，需要机器人分担人工客服的接待压力的时候，一般选择此模式)</span>
                    </el-radio>
                </el-radio-group>
            </div>
        </div>

        <div class="module-item-style" v-if="showRobotConfig">
            <div class="module-item-title robot-title-with-switch">
                <div>
                    机器人工作时间自定义
                </div>
                <div class="advanced-robot-switch-btn">
                    <el-switch
                            v-model="robotSwitchTimeBtn"
                            @click.native="saveChange('is_auto_robot_time', robotSwitchTimeBtn)"
                            active-color="#68B974">
                    </el-switch>
                </div>
            </div>
            <div class="advanced-robot-tips">设置后，机器人客服每天将会在设置的时间段内，根据选择的模式接待访客</div>
            <div class="advanced-content-container" v-if="robotSwitchTimeBtn">
                <!-- <el-time-picker
                        is-range
                        v-model="robotSwitchTime"
                        range-separator="~"
                        format="HH:mm"
                        value-format="timestamp"
                        @change="timeRangeSet"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围">
                </el-time-picker> -->
				<el-time-picker
					format="HH:mm"
					v-model="robotSwitchTime[0]">
				</el-time-picker>
				~
				<el-time-picker
					format="HH:mm"
					v-model="robotSwitchTime[1]">
				</el-time-picker>
				<div class="wl-btn robotSwitchTimeBtn" @click="timeRangeSet">确定</div>

            </div>
        </div>
		<!-- 是否开启自定义机器人接待时，文案引导  支持输入特定字符，转人工 -->
		<div class="module-item-style" v-if="showRobotConfig">
		    <div class="module-item-title robot-title-with-switch">
		        <div>
		            机器人转人工文本自定义
		        </div>
		        <div class="advanced-robot-switch-btn">
		            <el-switch
		                    v-model="robotOpenAutoRedirectBtn"
		                    @click.native="saveChange('is_open_input_auto_redirect', robotOpenAutoRedirectBtn)"
		                    active-color="#68B974">
		            </el-switch>
		        </div>
		    </div>
		    <div class="advanced-robot-tips">开启后，访客发送的文字与转人工自定义文字匹配时，会自动转人工，默认关闭</div>
		    <div class="advanced-content-container" v-if="robotOpenAutoRedirectBtn">
		        <div class="add-redirect-wrap">
					<el-input v-model="redirectContent" placeholder="请设置引导文字" maxlength="10" show-word-limit></el-input>
					<div class="wl-btn" @click="addRedirectContent">添加</div>
				</div>
				<div class="table-box redirect-table">
					<el-tag
					  v-for="tag in redirectContentList"
					  :key="tag.id"
					  closable
					  type="info"
					  @close="delRedirectContent(tag.id)">
					  {{tag.content}}
					</el-tag>
				</div>
		    </div>
			<div class="advanced-content-container input-auto-redirect-content-wrap">
				<div class="title-small">自动转接提示语设置</div>
				<el-input v-model="inputAutoRedirectContent"
				placeholder="请设置自动转接提示语"
				@blur="saveChange('input_auto_redirect_content', inputAutoRedirectContent)"></el-input>
			</div>
		</div>
		<div class="module-item-style">
			<div class="module-item-title">
				<div>相关问题引导语设置</div>
			</div>
			<div class="module-item-tips">提示相关问题的引导语设置，默认是"你可能还想问:"</div>
			<div class="input-auto-redirect-content-wrap">
				<el-input @blur="saveChange('response_more_like_this',relatedIssues)" v-model="relatedIssues" placeholder="请输入相关问题引导语"></el-input>
			</div>
		</div>
        <div class="module-item-style" v-show="showRobotConfig">
            <div class="module-item-title robot-title-with-switch">
                机器人欢迎语和常见语
            </div>
            <div class="advanced-robot-tips">每段对话开启时，系统自动向顾客发送一段欢迎语和常见问题列表</div>
            <div class="advanced-content-container">
                <wang-editor @editorBlurEvent="editorBlurEvent" ref="wangEditors" class="input-width zIndex9"></wang-editor>
            </div>

            <common-problem></common-problem>
        </div>

        <div class="module-item-style" v-if="showRobotConfig">
            <div class="module-item-title robot-title-with-switch">
                机器人未识别消息设置
            </div>
            <div class="advanced-robot-tips">当机器人没能回答出用户提出的问题时，可帮助机器人进行回答</div>
            <div class="advanced-content-container">
                <div class="robot-setting-recognition">
                    在识别

                    <el-select class="type-change" v-model="failed_threshold" placeholder="请选择"
                               @change="saveChange('failed_threshold',failed_threshold)">
                        <el-option

                                v-for="item in timesOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    次后
                    <el-select class="type-change" v-model="is_manual_switch" placeholder="请选择"
                               @change="saveChange('is_manual_switch',is_manual_switch)">
                        <el-option

                                v-for="item in noResOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    转人工
                </div>
                <div v-for="item in (Number(failed_threshold) - 1)">
                    <div class="small-title">第{{item}}次未识别</div>
                    <div class="can-edit-div-box">
                        <div contenteditable="true" v-if="item == 1" class="can-edit-div"
                             data-placeholder="欢迎，我是机器人小助手，请问遇到了什么问题吗？"
                             @blur="getEditDivChange($event,'response_cant_answer_1')"
                             v-html="robotTextObj.response_cant_answer_1">
                        </div>
                        <div contenteditable="true" v-if="item == 2" class="can-edit-div"
                             data-placeholder="欢迎，我是机器人小助手，请问遇到了什么问题吗？"
                             @blur="getEditDivChange($event,'response_cant_answer_2')"
                             v-html="robotTextObj.response_cant_answer_2">
                        </div>
                        <div contenteditable="true" class="can-edit-div" v-if="item == 3"
                             data-placeholder="欢迎，我是机器人小助手，请问遇到了什么问题吗？"
                             @blur="getEditDivChange($event,'response_cant_answer_3')"
                             v-html="robotTextObj.response_cant_answer_3">
                        </div>
                        <div contenteditable="true" class="can-edit-div" v-if="item == 4"
                             data-placeholder="欢迎，我是机器人小助手，请问遇到了什么问题吗？"
                             @blur="getEditDivChange($event,'response_cant_answer_4')"
                             v-html="robotTextObj.response_cant_answer_4">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="small-title">自动转人工文本自定义</div>
                    <div class="can-edit-div-box">
                        <div contenteditable="true" class="can-edit-div" data-placeholder="欢迎，我是机器人小助手，请问遇到了什么问题吗？"
                             v-html="robotTextObj.response_automatic_redirect"
                             @blur="getEditDivChange($event,'response_automatic_redirect')">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="small-title">手动转人工文本自定义</div>
                    <div class="can-edit-div-box">
                        <div contenteditable="true" class="can-edit-div" data-placeholder="欢迎，我是机器人小助手，请问遇到了什么问题吗？"
                             v-html="robotTextObj.response_manual_redirect"
                             @blur="getEditDivChange($event,'response_manual_redirect')">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="small-title">留言文本自定义</div>
                    <div class="can-edit-div-box">
                        <div contenteditable="true" class="can-edit-div" data-placeholder="欢迎，我是机器人小助手，请问遇到了什么问题吗？"
                             v-html="robotTextObj.response_reply" @blur="getEditDivChange($event,'response_reply')">
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="module-item-style" v-if="showRobotConfig">
            <div class="module-item-title robot-title-with-switch">
                机器人反馈消息设置
            </div>
            <div class="advanced-robot-tips">当用户对机器人回答进行反馈后，对相应反馈消息的设置</div>
            <div class="advanced-content-container">

                <div>
                    <div class="small-title">点击[已解决]</div>
                    <div class="can-edit-div-box">
                        <div contenteditable="true" class="can-edit-div" data-placeholder=""
                             v-html="robotTextObj.response_eval_useful"
                             @blur="getEditDivChange($event,'response_eval_useful')">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="small-title">点击[未解决]</div>
                    <div class="can-edit-div-box">
                        <div contenteditable="true" class="can-edit-div" data-placeholder=""
                             v-html="robotTextObj.response_eval_useless"
                             @blur="getEditDivChange($event,'response_eval_useless')">
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import commonProblem from './components/commonProblem'
    import wangEditor from '@/components/wangEditor'

    export default {
        name: 'setting-advanced-robot',
        components: {
            commonProblem,
            wangEditor
        },
        data() {
            let currentDateTimestamp = new Date(new Date().toLocaleDateString()).getTime() // 系统当天0点0时0分
            return {
                robotSwitchTimeBtn: false,
                robotSwitchTime: [currentDateTimestamp, currentDateTimestamp],
				robotOpenAutoRedirectBtn:false,
				redirectContentList:[],
				inputAutoRedirectContent:'',
				redirectContent:'',
                showMsgTips: true,
                robotSwitch: false,
                aiRobotSwitch: false,
                showRobotConfig: false,
                robotRule: '',
                robotName: '',
                messageCount: '0',
                robotHeadImg: '',
                failed_threshold: 1,
                is_manual_switch: 0,
                robotTextObj: {
                    response_automatic_redirect: '',
                    response_manual_redirect: '',
                    response_cant_answer_1: '',
                    response_cant_answer_2: '',
                    response_cant_answer_3: '',
                    response_cant_answer_4: '',
                    response_eval_useful: '',
                    response_eval_useless: '',
                    response_reply: '',
                    robot_welcome_text: '',
                },
				relatedIssues:"你可能还想问:",
                timesOptions: [
                    {label: '1', value: 1},
                    {label: '2', value: 2},
                    {label: '3', value: 3},
                    {label: '4', value: 4},
                    {label: '5', value: 5},
                ],
                noResOptions: [
                    {label: '自动', value: 0},
                    {label: '手动', value: 1}
                ],
                accept: 'image/gif, image/jpeg, image/png, image/jpg',
                is_auto_robot_time: '',
                auto_robot_open_time: '',
                auto_robot_close_time: '',
            }
        },
        created() {

        },
        mounted() {
            this.initRobotConfig()
            this.getRobotInfo()
            this.getRobotMsgNum()
			this.getRedirectContentList()
        },
        methods: {
            timeRangeSet() {
                this.auto_robot_open_time = this.$utils.timestampToTime(this.robotSwitchTime[0] / 1000).split(' ')[1]
                this.auto_robot_close_time = this.$utils.timestampToTime(this.robotSwitchTime[1] / 1000).split(' ')[1]
                console.log(this.$utils.timestampToTime(this.robotSwitchTime[0] / 1000))
                let params = {
                    openTime: this.auto_robot_open_time,
                    closeTime: this.auto_robot_close_time,
                }
                this.setRobotAutoTime(params)
            },
            setRobotAutoTime(params) {
                this.$http.setRobotAutoTimeAPI(params).then(res => {
                    if (res.status == 1) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success',
                        })
                        this.initRobotConfig()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            },
            changeRobotAvatar() {
                this.$refs.robotAvatar.click()
            },
            inputChange(e) {
                let img = e.target.files[0]
                let type = img.type
                let size = img.size
                if (this.accept.indexOf(type) == -1) {
                    this.$message({
                        showClose: true,
                        message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return false
                }
                if (size > 5242880) {
                    this.$message({
                        showClose: true,
                        message: '请选择5M以内的图片！',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return false
                }
                let formdata = new FormData()
                formdata.set('file', img)
                this.$http.uploadImageAPI(formdata).then(res => {
                    if (res.status == 1) {
                        this.robotHeadImg = res.data
                        this.editRobotInfo()
                    }
                })

            },
            closeTips() {
                this.showMsgTips = false
            },
            changeStatus() {
            },
            initRobotConfig() {
                this.$http.getRobotConfigAPI().then(res => {
                    if (res.status == 1) {
                        let robotInfo = res.data
                        if (robotInfo.is_open_robot == 1) {
                            this.robotSwitch = true
                            this.showRobotConfig = true
                        } else if (robotInfo.is_open_robot == 0) {
                            this.robotSwitch = false
                            this.showRobotConfig = false
                        }
                        if (robotInfo.is_auto_robot_time == 0) {
                            this.robotSwitchTimeBtn = false
                        } else if (robotInfo.is_auto_robot_time == 1) {
                            this.robotSwitchTimeBtn = true
                        }
                        if (robotInfo.is_open_input_auto_redirect == 0) {
                            this.robotOpenAutoRedirectBtn = false
                        } else if (robotInfo.is_open_input_auto_redirect == 1) {
                            this.robotOpenAutoRedirectBtn = true
                        }
                        // AI 智能客服开关初始化
                        if (robotInfo.is_open_ai_robot == 1) {
                            this.aiRobotSwitch = true
                        } else if (robotInfo.is_open_ai_robot == 0) {
                            this.aiRobotSwitch = false
                        }
                        this.inputAutoRedirectContent = robotInfo.input_auto_redirect_content
                        this.relatedIssues = res.data.response_more_like_this
                        // 获取当前日期
                        let date = new Date();
                        // 获取当前月份
                        let nowMonth = date.getMonth() + 1;
                        // 获取当前是几号
                        let strDate = date.getDate();
                        // 添加分隔符“-”
                        let seperator = "-";
                        // 对月份进行处理，1-9月在前面添加一个“0”
                        if (nowMonth >= 1 && nowMonth <= 9) {
                            nowMonth = "0" + nowMonth;
                        }
                        // 对月份进行处理，1-9号在前面添加一个“0”
                        if (strDate >= 0 && strDate <= 9) {
                            strDate = "0" + strDate;
                        }
                        // 最后拼接字符串，得到一个格式为(yyyy-MM-dd)的日期
                        let nowDate = date.getFullYear() + seperator + nowMonth + seperator + strDate;
                        let openTimeStr = nowDate + ' ' + robotInfo.auto_robot_open_time
                        let closeTimeStr = nowDate + ' ' + robotInfo.auto_robot_close_time
                        this.robotSwitchTime[0] = new Date(openTimeStr)
                        this.robotSwitchTime[1] = new Date(closeTimeStr)
                        this.robotRule = robotInfo.robot_rule
                        this.failed_threshold = robotInfo.failed_threshold
                        this.is_manual_switch = Number(robotInfo.is_manual_switch)
                        this.robotTextObj.robot_welcome_text = robotInfo.robot_welcome_text
                        this.robotTextObj.response_automatic_redirect = robotInfo.response_automatic_redirect
                        this.robotTextObj.response_manual_redirect = robotInfo.response_manual_redirect
                        this.robotTextObj.response_reply = robotInfo.response_reply
                        this.robotTextObj.response_eval_useless = robotInfo.response_eval_useless
                        this.robotTextObj.response_eval_useful = robotInfo.response_eval_useful
                        this.robotTextObj.response_cant_answer_1 = robotInfo.response_cant_answer_1
                        this.robotTextObj.response_cant_answer_2 = robotInfo.response_cant_answer_2
                        this.robotTextObj.response_cant_answer_3 = robotInfo.response_cant_answer_3
                        this.robotTextObj.response_cant_answer_4 = robotInfo.response_cant_answer_4
                        setTimeout(() => {
                            if (this.$refs.wangEditors) {
                                this.$refs.wangEditors.editor.txt.html(robotInfo.robot_welcome_text)
                            }

                        }, 1000)

                    }
                })
            },
            getRobotMsgNum() {
                this.$http.geiRobotMsgNumAPI().then(res => {
                    if (res.status == 1) {
                        this.messageCount = res.data.messageCount
                    }
                })
            },
            getRobotInfo() {
                this.$http.getRobotInfoAPI().then(res => {
                    if (res.status == 1) {
                        let robot = res.data
                        this.robotHeadImg = robot.csHeadimg
                        this.robotName = robot.csName
                    }
                })
            },
            editRobotInfo() {
                this.$http.editRobotInfoAPI({
                    "robotName": this.robotName,
                    "robotHeadimg": this.robotHeadImg
                }).then(res => {
                    if (res.status == 1) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                        this.getRobotInfo()
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            },
            // 编辑器组件抛出html的值
            editorBlurEvent(val) {
                // let reg = /&nbsp;/g;
                // const newVal = val.replace(/<(?!img).*?>/g,"") // 去除img以外的标签
                // if (newVal.replace(reg, '').trim().length == 0) {
                //   this.$message({
                //     message: '内容不能为空',
                //     type: 'error'
                //   })
                // } else {
                //
                // }
                this.saveChange('robot_welcome_text', val)
            },
            /**
             * 获取可编辑div内容的变化
             * @param event
             * @param name
             */
            getEditDivChange(event, name) {
                let val = event.target.innerHTML
                let valText = event.target.innerText
                if (this.robotTextObj[name] == val) {
                    return false
                }
                if (valText.trim().length == 0) {
                    if (name == 'robot_welcome_text') {
                        this.robotTextObj[name] = ''
                        event.target.innerHTML = ''
                    }
                    this.saveChange(name, '')
                } else {
                    this.saveChange(name, val)
                }

            },
            saveChange(name, value) {
                let postVal
                if (name == 'is_open_robot' || name == 'is_auto_robot_time' || name == 'is_open_input_auto_redirect' || name == 'is_open_ai_robot') {
                    if (value) {
                        postVal = 1
                    } else {
                        postVal = 0
                    }
                } else {
                    postVal = value
                }


                this.$http.robotConfigSettingAPI({
                    name,
                    value: postVal,
                }).then(res => {
                    if (res.status == 1) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                        this.initRobotConfig()
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            },
			// 获取引导转人工文字列表
			getRedirectContentList(){
				this.$http.redirectContentListAPI().then(res => {
					console.log(res)
					if(res.status==1){
						this.redirectContentList = res.data
					}
				})
			},
			addRedirectContent(){
				if(this.redirectContentList.length>9){
					this.$message({
					    message: '最多添加10条',
					    type: 'warning',
					})
					return false
				}
				if(this.redirectContent==''){
					this.$message({
					    message: '内容不能为空',
					    type: 'error',
					})
					return false
				}
				this.$http.addRedirectContentAPI({
					content:this.redirectContent
				}).then(res =>{
					console.log(res)
					if(res.status==1){
						this.redirectContent = ''
						this.getRedirectContentList()
						this.$message({
						    message: res.msg,
						    type: 'success',
						})
					}else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
				})
			},
			editRedirectContent(item){
				this.$http.editRedirectContentAPI({
					content:item.content,
					id:item.id
				}).then(res => {
					console.log(res)
					if(res.status==1){
						this.getRedirectContentList()
						this.$message({
						    message: res.msg,
						    type: 'success',
						})
					}else {
			            this.$message({
			                message: res.msg,
			                type: 'error',
			            })
			        }
				})
			},
			delRedirectContent(id){
				this.$http.delRedirectContentAPI({
					id:id
				}).then(res =>{
					console.log(res)
					if(res.status==1){
						this.getRedirectContentList()
						this.$message({
						    message: res.msg,
						    type: 'success',
						})
					}else {
			            this.$message({
			                message: res.msg,
			                type: 'error',
			            })
			        }
				})
			},
        }
    }
</script>

<style lang="scss">
    .setting-advanced-robot {
        .input-width {
            width: 600px;
			&.zIndex9{
				.w-e-toolbar .w-e-menu{
					z-index: 999!important;
				}
			}
        }
		.w-e-text{
			padding: 10px;
		}
		.robotSwitchTimeBtn{
			margin-left: 20px;
		}
        .setting-advanced-robot-num-tips {
            border-radius: $mainBorderRadius;
            background-color: #fff2d7;
            border: 1px solid #ffdf9c;
            margin-bottom: 10px;
            line-height: 40px;
            font-size: 12px;
            color: #666;
            display: flex;
            padding: 0 19px;
            position: relative;

            .msg-leave-num {
                font-size: 14px;
                color: #ff4e00;
                font-weight: bold;
                padding: 0 5px;
            }

            .robot-num-close-btn {
                position: absolute;
                right: 0px;
                top: 50%;
                margin-top: -9px;
                cursor: pointer;
            }
        }

        .advanced-robot-tips {
            color: #999;
            font-size: 12px;
            padding: 12px 0 15px 0;
        }

        .robot-title-with-switch {
            display: flex;

            .advanced-robot-switch-btn {
                margin-left: auto;
            }
        }

        .advanced-content-container {
            font-size: 12px;
            color: #666;

            .can-edit-div-box {
                width: 600px;
                height: 100px;
                border-radius: $mainBorderRadius;
                border: solid 1px #e4e7ed;
                padding: 8px;

                .can-edit-div {
                    width: 100%;
                    height: 100%;
                    outline: none;
                    overflow-y: scroll;

                    &:empty:before {
                        content: attr(data-placeholder);
                        color: #bbb;
                    }

                    &:focus:before {
                        content: none;
                    }
                }
            }

            .robot-model-container {
                .model-item {
                    display: block;
                    line-height: 30px;
                    color: #333;

                    .el-radio__label {
                        font-size: 12px;
                    }

                    white-space: inherit;

                    .model-item-desc {
                        color: #999;
                        display: block;
                        line-height: 1;
                        padding-left: 23px;
                    }
                }
            }

            .robot-setting-recognition {
                padding: 15px 0;

                .recognition-times {
                    width: 75px;
                    margin: 0 8px;
                }

                .type-change {
                    margin: 0 8px;
                    width: 80px;
                }
            }

            .small-title {
                color: #333;
                line-height: 40px;
            }
        }

        .link-to-knowledge {
            color: $mainColor;
            padding-left: 10px;
            cursor: pointer;
        }

        .robot-info-container {
            display: flex;
            align-items: center;

            .robot-avatar {
                width: 90px;
                height: 71px;
                padding-right: 22px;

                img {
                    width: 68px;
                    height: 68px;
                    border-radius: 50%;
                    overflow: hidden;
                }

            }
        }

        .robot-name {
            padding: 20px 0;
            display: flex;
            align-items: center;

            .robot-name-input {
                width: 200px;
            }

            .robot-name-label {
                padding-right: 12px;
                color: #333333;
            }
        }
		.add-redirect-wrap,.redirect-table{
			.el-input{
				width: 200px;
				margin-right: 20px;
			}
		}
		.redirect-table{
			.el-tag{
				margin-right: 25px;
				line-height: 40px;
				height: 40px;
				margin-bottom: 15px;
			}
		}
		.input-auto-redirect-content-wrap{
			.el-input{
				max-width: 400px;
				font-size: 12px;
			}
			.title-small{
				color: #333;
				line-height: 40px;
			}
		}
    }
</style>
